const containerClasses =
  "flex flex-col h-full overflow-hidden rounded-lg border border-border bg-[#323639]";

const toolbarClasses =
  "h-10 flex items-center gap-3 px-4 border-b border-black/30 shrink-0";
const toolbarIconClasses = "h-4 w-4 rounded-sm bg-white/15";
const toolbarLabelClasses = "h-3 w-28 rounded-sm bg-white/15";
const toolbarPillClasses = "h-5 w-12 rounded-sm bg-white/10";
const toolbarSpacerClasses = "flex-1";

const bodyClasses = "flex flex-1 min-h-0";

const sidebarClasses = "w-24 p-2 border-r border-black/30 shrink-0";
const thumbnailClasses =
  "w-full aspect-[8.5/11] bg-white/30 rounded-sm border-2 border-white/50";

const documentAreaClasses =
  "flex-1 flex justify-center items-start p-6 bg-[#525659] overflow-hidden";

const pageClasses =
  "w-full max-w-[700px] aspect-[8.5/11] bg-white rounded-sm " +
  "shadow-[0_4px_12px_rgba(0,0,0,0.4)] p-10 flex flex-col";

const shimmerBase =
  "relative overflow-hidden bg-primary-surface rounded-sm " +
  "after:content-[''] after:absolute after:inset-0 after:-translate-x-full " +
  "after:bg-[linear-gradient(90deg,transparent_0%,rgba(255,255,255,0.6)_45%,transparent_100%)] " +
  "after:animate-skeleton-shimmer";

const titleClasses = `${shimmerBase} h-7 w-[55%] mb-3`;
const dividerClasses = "h-px w-full bg-border-light mb-3";
const infoLineClasses = `${shimmerBase} h-3 w-[40%] mb-2`;
const infoLineShortClasses = `${shimmerBase} h-3 w-[28%] mb-2`;
const blockGapClasses = "h-5";
const sectionHeadingClasses = `${shimmerBase} h-5 w-[32%] mb-2`;
const subtleNoteClasses = `${shimmerBase} h-2.5 w-[18%] mb-3`;
const tableRowClasses = `${shimmerBase} h-3 w-full mb-2`;
const tableRowMidClasses = `${shimmerBase} h-3 w-[92%] mb-2`;

const PdfPreviewSkeleton = () => (
  <div className={containerClasses}>
    <div className={toolbarClasses}>
      <div className={toolbarIconClasses} />
      <div className={toolbarLabelClasses} />
      <div className={toolbarSpacerClasses} />
      <div className={toolbarPillClasses} />
      <div className={toolbarPillClasses} />
      <div className={toolbarSpacerClasses} />
      <div className={toolbarIconClasses} />
      <div className={toolbarIconClasses} />
      <div className={toolbarIconClasses} />
    </div>
    <div className={bodyClasses}>
      <div className={sidebarClasses}>
        <div className={thumbnailClasses} />
      </div>
      <div className={documentAreaClasses}>
        <div className={pageClasses}>
          <div className={titleClasses} />
          <div className={dividerClasses} />
          <div className={infoLineClasses} />
          <div className={infoLineShortClasses} />
          <div className={infoLineClasses} />
          <div className={infoLineShortClasses} />
          <div className={blockGapClasses} />
          <div className={dividerClasses} />
          <div className={sectionHeadingClasses} />
          <div className={subtleNoteClasses} />
          <div className={tableRowClasses} />
          <div className={tableRowClasses} />
          <div className={tableRowMidClasses} />
          <div className={tableRowClasses} />
        </div>
      </div>
    </div>
  </div>
);

export default PdfPreviewSkeleton;
